import React, { useEffect, useState } from "react";

import { CircularProgress } from "@mui/material";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Table from "@mui/material/Table";
import Box from "@mui/material/Box";
import { useTheme } from "@mui/material/styles";

import { EntityListEnum, UserDetailsDTO } from "@beable/roster-backend-client-v1";

import metricsService from "../../services/MetricsService";
import { getStyles } from "./styles";

interface AdminsTableProps {
  siteId: number;
  onAdminSelected: (admin: UserDetailsDTO) => void;
  selectedAdmin: UserDetailsDTO | undefined;
}

export default function AdminsTable({
  siteId,
  onAdminSelected,
  selectedAdmin,
}: AdminsTableProps) {
  const theme = useTheme();
  const styles = getStyles(theme);
  const [isLoading, setIsLoading] = useState(false);
  const [admins, setAdmins] = useState<UserDetailsDTO[]>([]);

  useEffect(() => {
    const fetchAdmins = async () => {
      setIsLoading(true);
      const fetchedAdmins = await metricsService.getEntityData(
        siteId,
        EntityListEnum.administrators,
        0,
        99
      );
      setIsLoading(false);

      if (fetchedAdmins && fetchedAdmins.length > 0) {
        setAdmins(fetchedAdmins as UserDetailsDTO[]);
      } else {
        setAdmins([]);
      }
    };
    fetchAdmins();
  }, [siteId]);

  return (
    <Box sx={styles.admins_root}>
      {isLoading ? (
        <Box sx={styles.loaderContainer}>
          <CircularProgress disableShrink />
        </Box>
      ) : null}
      {!isLoading ? (
        <Table size="small" aria-label="classes table">
          <TableHead>
            <TableRow>
              <TableCell>Firstname</TableCell>
              <TableCell>Lastname</TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {!isLoading &&
              admins &&
              admins.map((admin) => {
                return (
                  <TableRow
                    selected={
                      selectedAdmin &&
                      `${selectedAdmin.id}-${selectedAdmin.username}` ===
                        `${admin.id}-${admin.username}`
                    }
                    key={`${admin.id}-${admin.username}`}
                    sx={styles.clickable}
                    onClick={() => onAdminSelected(admin)}
                  >
                    <TableCell>{admin.firstName}</TableCell>
                    <TableCell>{admin.lastName}</TableCell>
                  </TableRow>
                );
              })}
          </TableBody>
        </Table>
      ) : null}
    </Box>
  );
}
